import { useSelector } from 'react-redux';
import uniq from 'lodash/uniq';
import { supplierRetailerUtils } from '../../../../utils/supplierRetailer';
import { ORDER_TYPE_DROPSHIP, ORDER_TYPE_MARKETPLACE } from '../../../../constants/orderTypes';

export const normalizeOrderType = (orderType) => {
  if (!orderType) return null;
  if (orderType === ORDER_TYPE_DROPSHIP) return orderType;
  return ORDER_TYPE_MARKETPLACE;
};

const filterInactiveConnections = (orderType) => orderType !== null;

export function getOrderTypeMetadata(retailers) {
  const normalizedOrderTypes = retailers
    .map((retailer) => normalizeOrderType(retailer?.order_type))
    .filter(filterInactiveConnections);

  const uniqueOrderTypes = uniq(normalizedOrderTypes);
  const retailerIdByOrderType = retailers.reduce(
    (orderTypeMap, retailer) => {
      const normalizedOrderType = normalizeOrderType(retailer.order_type);
      if (normalizedOrderType) orderTypeMap[normalizedOrderType].push(retailer.id);
      return orderTypeMap;
    },
    { dropship: [], marketplace: [] },
  );
  return {
    shouldDisplayOrderTypeFilter: uniqueOrderTypes.length > 1,
    retailerIdByOrderType,
  };
}

export function useShouldDisplayOrderTypeFilter() {
  const supplierRetailers = useSelector((state) => state.role.supplier.supplier_retailers);

  const analyticsRetailers = useSelector((state) => state.analytics.retailers);
  const analyticsRetailerIds = supplierRetailerUtils
    .setRetailersActiveStatus(analyticsRetailers)
    .map((retailer) => retailer.id);

  const retailers = supplierRetailers
    .map(({ retailer }) => retailer)
    .filter((retailer) => analyticsRetailerIds.includes(retailer.id));

  if (!retailers?.length) return { shouldDisplayOrderTypeFilter: false };
  return getOrderTypeMetadata(retailers);
}
